<template>
  <div class="foundFrecastRMB">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
      @forecastDateChange="forecastDateChange"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          type="index"
          :title="$t('currenciesAndCalendar.queryCurrencies.index')"
          width="60"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.totalFlag === `totalFlag`">{{
              $t('fundFrecast.button.total')
            }}</span>
            <span v-else>{{ scope.rowIndex + 1 }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="forecastDepartmentCode"
          :title="$t('fundFrecast.column.departmentName')"
          width="120"
        >
          <template v-slot="{ row }">
            <p>{{ row.forecastDepartmentName }}</p>
          </template>
        </vxe-table-column>

        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.prop] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.prop] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.formatBank">
              {{ getSelectLabel(scope.row, scope.row[item.prop], financingBankList) }}
            </span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-dialog
      :title="$t('fundFrecast.column.bankRestAmount')"
      :visible.sync="dialogTableVisible"
      width="80%"
    >
      <el-form ref="bankBalanceFrom" :rules="rules" :model="bankBalanceFrom" label-width="80px">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('fundFrecast.column.forecastDate')" prop="data">
              <el-date-picker
                v-model="bankBalanceFrom.data"
                type="date"
                :placeholder="$t('fundFrecast.placeholder.forecastDate')"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('fundFrecast.column.bankRestAmount')" prop="balance">
              <el-input
                v-model="bankBalanceFrom.balance"
                type="number"
                max="99999999999.999999"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item
              :label="$t('fundFrecast.column.planCycle')"
              prop="planCycle"
            >
              <el-select
              v-model="bankBalanceFrom.planCycle"
              filterable
            >
              <el-option
                v-for="item in planWeekList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item :label="$t('fundFrecast.column.currencyType')" prop="currencyType">
              <el-select v-model="bankBalanceFrom.currencyType" filterable disabled>
                <el-option
                  v-for="item in currencyList"
                  :key="item.value"
                  :label="item.label + '  ' + item.value"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="resetForm('bankBalanceFrom')">{{
          this.$t('fundFrecast.button.cancel')
        }}</el-button>
        <el-button type="primary" @click="sureBankBalance('bankBalanceFrom')">{{
          this.$t('fundFrecast.button.confirm')
        }}</el-button>
      </div>
      <!-- 查看维护银行余额记录 -->
      <div class="bankBalance">
        <template>
          <div class="collapse-title-pre bankBalanceInfo"
            ><span></span>{{ this.$t('fundFrecast.table.bankBalanceInfo') }}</div
          >
        </template>
        <bank-balance ref="bankBalanceRef" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import SiruiTable from '@/components/SiruiTable';
  import SiruiSearch from '@/components/SiruiSearch';
  import BankBalance from './components/bankBalance';
  import { mapState } from 'vuex';
  import BASEAPI from '@/api/dataBase.js';
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/capitalPlane/foundFrecast';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'foundFrecastRMB',
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
      BankBalance,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            //公司
            prop: 'forecastCompanyCode',
            name: this.$t('fundFrecast.column.company'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'changeCompany',
          },
          // {
          //   //事业部
          //   prop: "forecastDepartmentCode",
          //   name: this.$t("fundFrecast.column.department"),
          //   type: "treeSelect",
          //   apiUrl:BASEAPI.LIST_COMPANY_API,
          //   apiData: {
          //     tenantCode: this.userInfo.tenantCode,
          //     adminFlag: this.userInfo.adminFlag
          //   },
          //   multiple:true,
          //   isName: false,
          //   clearable: false
          // },
          //事业部
          {
            prop: 'forecastDepartmentCode',
            name: this.$t('fundFrecast.column.department'),
            type: 'select',
            options: this.departmentList,
          },
          {
            //计划周期
            prop: 'planCycle',
            name: this.$t('fundFrecast.column.planCycle'),
            type: 'dict',
            dictType: 'capitalPlan_plan_week',
          },
          {
            // 年度
            prop: 'forecastYear',
            name: this.$t('fundFrecast.column.forecastYear'),
            type: 'year',
            format: 'yyyy',
          },
          {
            //月份
            prop: 'forecastMonth',
            name: this.$t('fundFrecast.column.forecastMonth'),
            type: 'select',
            options: this.monthList(),
            changeMethod: 'forecastDateChange',
          },
          {
            //计划开始日期
            prop: 'planStartDate',
            name: this.$t('fundFrecast.column.planStartDate'),
            type: 'date',
            forecastYear: this.query.forecastYear,
            forecastMonth: this.query.forecastMonth,
          },
          {
            //计划结束日期
            prop: 'planEndDate',
            name: this.$t('fundFrecast.column.planEndDate'),
            type: 'date',
            forecastYear: this.query.forecastYear,
            forecastMonth: this.query.forecastMonth,
          },
          /* {
          //日期
          prop: "forecastDate",
          name: this.$t("fundFrecast.column.forecastDate"),
          type: "date",
          forecastYear:this.query.forecastYear,
          forecastMonth:this.query.forecastMonth,
        }, */
        ];
      },
      //表格显示字段
      columnListDefault() {
        return [
          { prop: 'forecastYear', label: this.$t('fundFrecast.column.forecastYear'), width: 120 },
          { prop: 'forecastMonth', label: this.$t('fundFrecast.column.forecastMonth'), width: 120 },
          { prop: 'forecastDate', label: this.$t('fundFrecast.column.forecastDate') },
          {
            prop: 'financeBank',
            label: this.$t('fundFrecast.column.financeBank'),
            formatBank: 'financeBank',
          }, //自定义格式根据融资银行编码取值
          {
            prop: 'financeVariety',
            label: this.$t('fundFrecast.column.financeVariety'),
            dictType: 'finance_variety',
          },
          { prop: 'receiveAmount', label: this.$t('fundFrecast.column.receiveAmount') },
          { prop: 'payAmount', label: this.$t('fundFrecast.column.payAmount') },
          {
            prop: 'planCycle',
            label: this.$t('fundFrecast.column.planCycle'),
            dictType: 'capitalPlan_plan_week',
          },
          { prop: 'planStartDate', label: this.$t('fundFrecast.column.planStartDate') },
          { prop: 'planEndDate', label: this.$t('fundFrecast.column.planEndDate') },
          {
            prop: 'originFlag',
            label: this.$t('fundFrecast.column.originFlag'),
            dictType: 'origin_flag',
          },
          { prop: 'planRestAmount', label: this.$t('fundFrecast.column.planRestAmount') },
          //{ prop: "bankRestAmount", label: this.$t("fundFrecast.column.bankRestAmount") },
        ];
      },
    },
    data() {
      return {
        bankBalanceFrom: {
          data: new Date(),
          balance: '',
          //planCycle:'',
          currencyType: 'CNY',
        },
        rules: {
          data: [
            {
              required: true,
              message: this.$t('fundFrecast.placeholder.forecastDate'),
              trigger: 'blur',
            },
          ],
          balance: [
            {
              required: true,
              message: this.$t('fundFrecast.placeholder.bankRestAmount'),
              trigger: 'blur',
            },
          ],
          planCycle: [
            {
              required: true,
              message: this.$t('fundFrecast.placeholder.planCycle'),
              trigger: 'blur',
            },
          ],
          currencyType: [
            {
              required: true,
              message: this.$t('fundFrecast.placeholder.currencyType'),
              trigger: 'blur',
            },
          ],
        },
        load: false,
        dialogTableVisible: false,
        menuButtonList: [], //按钮
        companyList: [], //公司
        departmentList: [], //部门
        currencyList: [], //币别
        planWeekList: [], //计划周期
        monthList() {
          //月份
          var mon = [];
          for (let i = 1; i < 13; i++) {
            mon.push({ label: i + this.$t('fundFrecast.column.month'), value: i });
          }
          return mon;
        },
        query: {
          // 搜索条件
          forecastCompanyCode: null, //公司
          forecastDepartmentCode: null, //事业部门
          planCycle: 'MP', //计划周期
          forecastYear: this.getCurrentYear() + '', //年度--默认显示当前年
          forecastMonth: this.getCurrentMonth(), //月份--默认显示当前月
          planStartDate: null, //日期
          planEndDate: null, //日期
          /* startForecastDate: null, //日期
        endForecastDate: null, //日期 */
        },
        multipleSelection: [], //选中数据
        financingBankList: [], //融资银行
        tableData: [],
      };
    },
    watch: {
      'query.forecastYear': {
        handler() {
          this.query.planStartDate = null;
          this.query.planEndDate = null;
          /* this.query.startForecastDate=null;
          this.query.endForecastDate=null; */
        },
      },
    },
    mounted() {
      this.getDictionary();
      this.getButtonList();
      this.getCompany();
    },
    methods: {
      getData() {
        if (this.query.forecastCompanyCode == '') {
          this.$message.warning(this.$t('fundFrecast.placeholder.company'));
          return;
        }
        if (!this.query.planCycle) {
          this.$message.warning(this.$t('fundFrecast.placeholder.planCycle'));
          return;
        }
        if (this.query.planCycle == 'HMP' || this.query.planCycle == 'CP') {
          if (!this.query.planStartDate || !this.query.planEndDate) {
            return this.$message({
              message: this.$t('businesDepartment.message.hmpOrCpEmpty'),
              type: 'error',
            });
          }
        }
        if (this.query.forecastYear == '' || this.query.forecastYear == null) {
          this.$message.warning(this.$t('fundFrecast.placeholder.forecastYear'));
          return;
        }
        if (this.query.forecastMonth == '') {
          this.$message.warning(this.$t('fundFrecast.placeholder.forecastMonth'));
          return;
        }
        let params = JSON.parse(JSON.stringify(this.query));
        this.$axios.post(API.QUERY_LIST, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data;
            //查询时显示合计一行
            this.showTotal('query');
            if (this.tableData.length == 1) {
              this.tableData = [];
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //获取计划周期
      async getPlanWeekList() {
        let params = {
          dictType: 'capitalPlan_plan_week',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.planWeekList = selectStatus.data.data;
        }
      },
      //获取币别
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          selectStatus.data.data.map((item) => {
            let obj = {
              value: item.currencyCode,
              label: item.currencyName,
            };
            this.currencyList.push(obj);
          });
        }
      },
      // 获取当前年度
      getCurrentYear() {
        let date = new Date();
        return date.getFullYear();
      },
      // 获取当前月份
      getCurrentMonth() {
        let date = new Date();
        let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : date.getMonth() + 1;
        return month;
      },

      //字典
      getDictionary() {
        this.getBankList();
        this.getCurrencyList();
        this.getPlanWeekList();
      },

      //公司代码
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
          this.query.forecastCompanyCode = this.userInfo.companyCode || this.companyList[0].value;
          this.changeCompany({ val: this.query.forecastCompanyCode });
        }
        this.getData();
      },

      // 获取公司部门
      async changeCompany(val) {
        this.query.forecastDepartmentCode = null;
        if (val.val) {
          let res = await this.$baseRequest.getDepartment(val.val);

          if (res) {
            this.departmentList = res;
          }
        } else {
          this.departmentList = [];
        }
      },
      sureBankBalance(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //解决 axios 提交时间类型参数遇到的时区自动转换问题
            let params = {
              forecastCompanyCode: this.query.forecastCompanyCode,
              forecastDate: this.formatDate(this.bankBalanceFrom.data, 'yyyy-MM-dd'),
              balanceAmount: this.bankBalanceFrom.balance,
              currencyType: this.bankBalanceFrom.currencyType,
              //planCycle:this.bankBalanceFrom.planCycle,
            };
            params = this.$baseRequest.assignObj(params);
            this.$axios.post(API.SET_FUND_PLAN_BALANCE, params).then((res) => {
              if (0 == res.data.code) {
                this.$message({
                  showClose: true,
                  message: this.$t('fundFrecast.button.saveSussess'),
                  type: 'success',
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
            this.dialogTableVisible = false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogTableVisible = false;
      },
      //表格日期组件回调
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      //获取按钮
      getButtonList() {
        this.menuButtonList = [
          {
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-upload',
              buttonUrl: 'export',
            },
            label: this.$t('fundFrecast.button.export'),
          },
          {
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-edit',
              buttonUrl: 'total',
            },
            label: this.$t('fundFrecast.button.total'),
          },
          {
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-edit',
              buttonUrl: 'maintainBankBalance',
            },
            label: this.$t('fundFrecast.button.maintainBankBalance'),
          },
        ];
      },
      forecastDateChange() {
        this.query.planStartDate = null;
        this.query.planEndDate = null;
        //this.query.startForecastDate=null;
        //this.query.endForecastDate=null;
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'export') {
          //导出
          this.handleExport();
        } else if (type == 'total') {
          //合计
          this.showTotal();
        } else if (type == 'maintainBankBalance') {
          //维护银行余额
          this.dialogTableVisible = true;
          this.$nextTick(() => {
            this.$refs.bankBalanceRef.getData();
          });
        }
      },

      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getCompany();
      },
      //获取融资银行
      async getBankList() {
        this.financingBankList = await this.$baseRequest.getMDBank();
        this.financingBankList = this.financingBankList.map((item) => {
          return { value: item.bankCode, label: item.bankName };
        });
      },
      //表格回显方法
      getSelectLabel(row, value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        //解决融资银行翻译过后，合计一行本月使用无法出现的问题
        if (row.totalFlag == 'totalFlag') {
          return this.$t('fundFrecast.placeholder.totoalPayAmount');
        }
        return item ? item[labelField] : null;
      },
      showTotal(type) {
        /* let multipleSelection = this.multipleSelection;
      if (multipleSelection.length > 0) {
        let id = multipleSelection[multipleSelection.length - 1].id;
        let indexFlag = 0;
        let object = {
          planningCycle: "上月可用余额",
          year: "",
          typeOfPayment: "本月新增",
          cooperativePartner: "",
          Number: "本月使用",
          unitPrice: "",
          receiptAndpaymentMethod: "月底可用余额",
          amountCollected: "",
          paymentAmount: "",
          dateOfPayment: "",
        };
        this.tableData.forEach((item, index) => {
          if (item.id == id) {
            indexFlag = index + 1;
          }
        });

        this.tableData.splice(indexFlag, 0, object);
      } else {
        this.$message({
          showClose: true,
          message: res.data.msg,
          type: "success",
        });
      } */

        let indexFlag = 0;
        let deleteIndex = 0;

        this.tableData.forEach((item, index) => {
          if (item.totalFlag == 'totalFlag') {
            indexFlag = index;
            deleteIndex = 1;
          }
        });
        let params = JSON.parse(JSON.stringify(this.query));
        let paramsTotal = {
          ...params,
          ...{
            foreignCurrencyType: 'CNY',
            forecastYear: XEUtils.isNull(this.query.forecastYear)
              ? this.getCurrentYear() + ''
              : this.query.forecastYear, // 年份无值即取当前年度
            forecastMonth:
              this.query.forecastMonth == '' ? this.getCurrentMonth() : this.query.forecastMonth, // 月份无值即取当前月份
          },
        };
        this.$axios.post(API.COMBINED, paramsTotal).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            let object = {
              forecastDepartmentName: this.$t('fundFrecast.placeholder.lastMonthRemaining'),
              forecastYear: type === 'query' ? '' : res.data.data.lastMonthRemaining,
              forecastMonth: this.$t('fundFrecast.placeholder.totoalReceiveAmount'),
              forecastDate: type === 'query' ? '' : res.data.data.totoalReceiveAmount,
              financingBank: this.$t('fundFrecast.placeholder.totoalPayAmount'),
              financeVariety: type === 'query' ? '' : res.data.data.totoalPayAmount,
              receiveAmount: this.$t('fundFrecast.placeholder.remaining'),
              payAmount: type === 'query' ? '' : res.data.data.remaining,
              planRestAmount: '',
              bankRestAmount: '',
              totalFlag: 'totalFlag',
            };
            this.tableData.splice(indexFlag, deleteIndex, object);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 导出
      handleExport() {
        if (this.tableData.length == 1 && this.tableData[0].totalFlag) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        let params = { ...this.query };
        params = this.$baseRequest.assignObj(params);
        params = XEUtils.serialize(params);
        window.location.href = `${baseUrl}${API.FORECAST_EXPORT_EXCEL}?${params}&access_token=${this.userInfo.access_token}`;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .foundFrecastRMB .el-dialog__footer {
    padding: 12px 18px;
    border-top: 1px solid #e8eaec;
    text-align: center !important;
  }
  .dialog-footer {
    text-align: center;
  }
  .foundFrecastRMB .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }
  .foundFrecastRMB .bankBalanceInfo {
    margin-bottom: 20px;
  }
</style>
